import { DateConverter } from '@/model/converters/datesConverters';
import { CustomConverter, JsonObject, JsonProperty, Optional } from 'json-ts-mapper';
import { AdresseCommandeSAS } from './adresse-commande-sas';
import { ReglementCommandeSAS } from './reglement-commande-sas';

@JsonObject
export class LigneCommandeSAS {
  constructor (
    numeroCommande?: string,
    numeroLigne?: number,
    numArticle?: string,
    libelleArticle?: string,
    quantite?: number,
    unite?: string,
    adresseLivraison?: AdresseCommandeSAS,
    dateDebutLivr?: Date,
    dateFinLivr?: Date,
    modeCamion?: string,
    codeLieuDepart?: string,
    etape?: string,
    reglement?: ReglementCommandeSAS
  ) {
    this.numeroCommande = numeroCommande as any;
    this.numeroLigne = numeroLigne as any;
    this.numArticle = numArticle as any;
    this.libelleArticle = libelleArticle as any;
    this.quantite = quantite as any;
    this.unite = unite as any;
    this.adresseLivraison = adresseLivraison as any;
    this.dateDebutLivr = dateDebutLivr as any;
    this.dateFinLivr = dateFinLivr as any;
    this.modeCamion = modeCamion as any;
    this.codeLieuDepart = codeLieuDepart as any;
    this.etape = etape as any;
    this.reglement = reglement as any;
  }

  @JsonProperty(Number)
  numeroLigne?: number;

  // -------------------
  // Uniquement utilisé pour le mapping du détail de la commande
  // depuis la carte historique sur Mon compte
  @JsonProperty(String)
  @Optional
  numeroCommande?: string;

  @JsonProperty(String)
  @Optional
  @CustomConverter(DateConverter)
  dateCommande?: Date
  // -------------------

  @JsonProperty(String)
  numArticle?: string;

  @JsonProperty(String)
  libelleArticle?: string;

  @JsonProperty(Number)
  quantite?: number;

  @JsonProperty(String)
  unite?: string;

  @JsonProperty(AdresseCommandeSAS)
  adresseLivraison?: AdresseCommandeSAS;

  @JsonProperty(String)
  @CustomConverter(DateConverter)
  dateDebutLivr: Date;

  @JsonProperty(String)
  @CustomConverter(DateConverter)
  dateFinLivr: Date;

  @JsonProperty(String)
  modeCamion?: string;

  @JsonProperty(String)
  codeLieuDepart?: string;

  @JsonProperty(String)
  etape?: string;

  @JsonProperty(ReglementCommandeSAS)
  reglement?: ReglementCommandeSAS;
}
